<template>
	<v-app style="overflow: hidden">
		<v-container fluid class="pa-0 ma-0" style="height: 100%; overflow: hidden">
			<v-row
				dense
				class="pa-0 ma-0"
				style="background-color: black; height: 100%"
			>
				<v-col class="pa-0 ma-0" cols="12" xl="9" lg="9" md="12" sm="12">
					<v-card class="video-room-video ma-0" color="black" height="100%">
						<div v-if="callEnded">
							<span>Call Ended</span><br />
							<v-btn @click="reJoin"
								>Rejoin<v-icon small>mdi-arrow-left-bottom</v-icon></v-btn
							>
						</div>
						<v-card-text class="pa-3" style="height: 100%; overflow: hidden">
							<v-row v-if="!callEnded" style="height: 100%">
								<v-col :cols="12" class="d-flex flex-column justify-center align-center">
									<div class="remote-video-stage" :style="remoteStageStyle">
										<v-card
											v-if="!videoTrack"
											color="black"
											class="d-flex flex-column justify-center align-center"
											:height="lockedVideoStageHeight"
										>
											<v-card-text>
												<v-avatar class="mt-16" color="secondary" size="240">
													<span
														v-if="userDetails"
														class="font-weight-bold black--text"
														style="font-size: 36px"
														>{{ userDetails.firstName.charAt(0)
														}}{{ userDetails.lastName.charAt(0) }}</span
													>
												</v-avatar>
											</v-card-text>
										</v-card>
										<video
											v-show="videoTrack"
											autoplay
											:height="lockedVideoStageHeight"
											style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"
											preload="none"
											poster="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYniamX9xxvMlgmWIrZXmiueRb_Errvrqkaw&usqp=CAU"
											id="patientvideo"
										></video>
										<audio id="remoteaudio" class="remote-audio-element" autoplay playsinline></audio>
										<div v-if="videoTrack" class="local-overlay">
											<v-card
												v-if="mutedVideo"
												color="secondary"
												class="d-flex flex-column justify-center align-center fill-height"
												style="border-radius: 8px"
											>
												<v-card-text>
													<v-avatar color="grey" size="96">
														<span
															v-if="userDetails"
															class="font-weight-bold black--text"
															style="font-size: 24px"
														>
															{{ loggedUser.firstName.charAt(0) }}{{ loggedUser.lastName.charAt(0) }}
														</span>
													</v-avatar>
												</v-card-text>
											</v-card>
											<video
												v-show="!mutedVideo"
												autoplay
												style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"
												preload="none"
												poster="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYniamX9xxvMlgmWIrZXmiueRb_Errvrqkaw&usqp=CAU"
												muted
												id="localvideo"
											></video>
										</div>
										<div class="floating-call-controls">
											<v-btn fab class="mx-2" @click="stopAudio">
												<v-icon v-if="!mutedAudio">mdi-microphone</v-icon>
												<v-icon v-if="mutedAudio">mdi-microphone-off</v-icon>
											</v-btn>
											<v-btn v-if="videoTrack" fab class="mx-2" @click="stopVideo">
												<v-icon v-if="!mutedVideo">mdi-video</v-icon>
												<v-icon v-if="mutedVideo">mdi-video-off</v-icon>
											</v-btn>
											<v-btn fab class="mx-2" color="red" @click="endCall">
												<v-icon color="white">mdi-phone-hangup</v-icon>
											</v-btn>
										</div>
									</div>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col
					class="pa-0 ma-0"
					style="background-color: white"
					cols="12"
					xl="3"
					lg="3"
					md="12"
					sm="12"
				>
					<patient-details-card v-if="detailedUser" />
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>
<script>
import Janus from 'janus-gateway';
import { mapState } from 'vuex';
import PatientDetailsCard from '@/views/Client/components/PatientDetailsCard.vue';
import { seeMoreWhite } from '@/assets/';

var socketUrl = process.env.VUE_APP_JANUS_SERVER_URL;

var vroomHandle = null;
var Vue = null;
export default {
	name: 'App',
	components: {
		PatientDetailsCard,
	},
	data () {
		return {
			janus: null,
			loading: false,
			rerender: 1,
			toggle: null,
			notes: '',
			mutedAudio: false,
			showChat: false,
			mutedVideo: false, // Changed to false to show local video initially
			disabledVideo: false,
			disabledAudio: false,
			publishers: [],
			callEnded: false,
			snackStatus: false,
			title: '',
			myNotes: null,
			snackColor: '',
			see_more_white: seeMoreWhite,
			showNotesDialog: false,
			roomJoinId: null,
			localPrivateId: null,
			needsToBeRecorded: null,
			videoPublishRetryCount: 0,
			localPreviewStream: null,
			remoteFeedsByFeedId: {},
			remoteTrackDebugById: {},
			remoteTrackTimeoutsByKey: {},
			lockedVideoStageHeight: 0,
			isTearingDown: false,
		};
	},
	computed: {
		...mapState({
			loggedUser: (state) => state.authentication.userData,
			detailedUser: (state) => state.users.detailedUser,
			notesFromRepo: (state) => state.appointments.notes,
		}),
		videoTrack () {
			return this.parseRouteBoolean(this.$route.params.videotrack);
		},
		appointmentDetails () {
			return this.$route.params.details;
		},
		remoteStageStyle () {
			const height = this.lockedVideoStageHeight > 0 ? `${this.lockedVideoStageHeight}px` : '80vh';
			return {
				height: height,
				maxHeight: height,
			};
		},
		userDetails () {
			return this.detailedUser?.userData;
		},
		returnimage () {
			return 'https://icons.veryicon.com/png/o/object/material-design-icons-1/account-outline.png';
		},
		fistPublisher () {
			return this.publishers[0]?.id;
		},
		videoRowHeight () {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return window.innerHeight * 0.8;
				case 'sm':
					return window.innerHeight * 0.8;
				case 'md':
					return window.innerHeight * 0.8;
				case 'lg':
					return window.innerHeight * 0.8;
				case 'xl':
					return window.innerHeight * 0.8;
				default:
					return 0;
			}
		},
		alignment () {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return 'col-center-alignment';
				case 'sm':
					return 'col-center-alignment';
				case 'md':
					return 'col-center-alignment';
				case 'lg':
					return 'col-left-alignment';
				case 'xl':
					return 'col-left-alignment';
				default:
					return 'col-left-alignment';
			}
		},
	},
	async mounted () {
		this.refreshLockedVideoStageHeight();
		window.addEventListener('resize', this.refreshLockedVideoStageHeight);
		localStorage.appointmentIdToStop = this.$route.params.appointmentId;
		// if (localStorage.sessionToken === undefined) {
		// 	localStorage.sessionToken = this.$route.params.token;
		// 	await this.$store.dispatch('authentication/doLoginWithToken');
		// } else {
		// 	await this.$store.dispatch('authentication/doLoginWithToken');
		// }
		if (this.$route.params.id && this.$route.params.userId) {
			await this.getUserById(this.$route.params.userId);
			this.init(
				parseInt(this.$route.params.id),
				this.$route.params.needVideoRecording,
			);
		}
		this.rerender += 1;
		this.getAllNotes();
	},
	beforeDestroy () {
		this.teardownRealtimeMedia();
	},
	async destroyed () {
		Vue = null;
		await this.addAttendeeForAppointment(
			localStorage.appointmentIdToStop,
			'OUT',
		);
		await this.stopAppointment(localStorage.appointmentIdToStop);
		localStorage.removeItem('appointmentIdToStop');
	},
	methods: {
		parseRouteBoolean (value) {
			if (Array.isArray(value)) {
				return this.parseRouteBoolean(value[0]);
			}
			return value === true || value === 'true' || value === 1 || value === '1';
		},
		refreshLockedVideoStageHeight () {
			const nextHeight = Math.max(320, Math.floor(window.innerHeight * 0.8));
			this.lockedVideoStageHeight = nextHeight;
		},
		clearRemoteTrackTimeouts () {
			Object.keys(this.remoteTrackTimeoutsByKey).forEach((key) => {
				const timeoutId = this.remoteTrackTimeoutsByKey[key];
				if (timeoutId) {
					clearTimeout(timeoutId);
				}
			});
			this.remoteTrackTimeoutsByKey = {};
			this.remoteTrackDebugById = {};
		},
		releaseAttachedMedia () {
			const localVideo = document.getElementById('localvideo');
			const remoteVideo = document.getElementById('patientvideo');
			const remoteAudio = document.getElementById('remoteaudio');
			[localVideo, remoteVideo, remoteAudio].forEach((element) => {
				if (!element) return;
				if (element.srcObject && typeof element.srcObject.getTracks === 'function') {
					element.srcObject.getTracks().forEach((track) => {
						try {
							track.stop();
						} catch (error) {
							// Ignore per-track stop failures.
						}
					});
					element.srcObject = null;
				}
				if (typeof element.pause === 'function') {
					element.pause();
				}
			});
			if (this.localPreviewStream) {
				this.localPreviewStream.getTracks().forEach((track) => {
					try {
						track.stop();
					} catch (error) {
						// Ignore per-track stop failures.
					}
				});
				this.localPreviewStream = null;
			}
		},
		teardownRealtimeMedia () {
			if (this.isTearingDown) return;
			this.isTearingDown = true;
			window.removeEventListener('resize', this.refreshLockedVideoStageHeight);
			this.clearRemoteTrackTimeouts();
			this.releaseAttachedMedia();
			this.detachAllRemoteFeeds();
			if (vroomHandle) {
				try {
					vroomHandle.hangup();
				} catch (error) {
					// Ignore hangup failures during teardown.
				}
				try {
					if (typeof vroomHandle.detach === 'function') {
						vroomHandle.detach({
							success: () => {},
							error: () => {},
						});
					}
				} catch (error) {
					// Ignore detach failures during teardown.
				}
				vroomHandle = null;
			}
			if (this.janus) {
				try {
					this.janus.destroy();
				} catch (error) {
					// Ignore Janus destroy failures during teardown.
				}
				this.janus = null;
			}
			this.callEnded = true;
		},
		normalizeFeedId (feedId) {
			if (feedId === undefined || feedId === null) return null;
			return String(feedId);
		},
		logJanusPhase (phase, payload) {
			// console.log('[JANUS_PHASE]', {
			// 	phase: phase,
			// 	at: new Date().toISOString(),
			// 	roomId: this.$route.params.id,
			// 	appointmentId: this.$route.params.appointmentId,
			// 	...(payload || {}),
			// });
		},
		detachRemoteFeed (feedId) {
			const key = this.normalizeFeedId(feedId);
			if (!key) return;
			const remoteFeed = this.remoteFeedsByFeedId[key];
			if (remoteFeed && remoteFeed.remoteMediaStream && typeof remoteFeed.remoteMediaStream.getTracks === 'function') {
				remoteFeed.remoteMediaStream.getTracks().forEach((track) => {
					try {
						track.stop();
					} catch (error) {
						// Ignore per-track stop failures.
					}
				});
			}
			if (remoteFeed && typeof remoteFeed.detach === 'function') {
				remoteFeed.detach({
					success: () => {},
					error: () => {},
				});
			}
			this.$delete(this.remoteFeedsByFeedId, key);
		},
		detachAllRemoteFeeds () {
			Object.keys(this.remoteFeedsByFeedId).forEach((key) => {
				const remoteFeed = this.remoteFeedsByFeedId[key];
				if (remoteFeed && remoteFeed.remoteMediaStream && typeof remoteFeed.remoteMediaStream.getTracks === 'function') {
					remoteFeed.remoteMediaStream.getTracks().forEach((track) => {
						try {
							track.stop();
						} catch (error) {
							// Ignore per-track stop failures.
						}
					});
				}
				if (remoteFeed && typeof remoteFeed.detach === 'function') {
					remoteFeed.detach({
						success: () => {},
						error: () => {},
					});
				}
			});
			this.remoteFeedsByFeedId = {};
		},
		showMessages () {
			this.showChat = !this.showChat;
		},

		async startAppointment (appointmentId) {
			const body = {
				appointmentId: appointmentId,
			};
			this.$store.dispatch('appointments/startAppointment', body);
		},
		stopAppointment (appointmentId) {
			const body = {
				appointmentId: appointmentId,
			};
			this.$store.dispatch('appointments/stopAppointment', body);
		},
		async addAttendeeForAppointment (appointmentId, joinType) {
			const body = {
				appointmentId: appointmentId,
				attendeeId: this.loggedUser.id,
				joinType: joinType,
				roomJoinId: this.roomJoinId,
			};
			this.$store.dispatch('appointments/addAttendeeForAppointment', body);
		},
		async getUserById (userId) {
			await this.$store.dispatch('users/getUserById', userId);
		},
		reJoin () {
			this.isTearingDown = false;
			this.callEnded = false;
			this.mutedAudio = false;
			this.mutedVideo = false; // Reset video mute state on rejoin
			this.videoPublishRetryCount = 0;
			this.init(
				parseInt(this.$route.params.id),
				this.$route.params.needVideoRecording,
			); // Pass recording param
		},
		async endCall () {
			try {
				this.teardownRealtimeMedia();

				// Redirect to previous page or dashboard
				this.$router.go(-1);
			} catch (error) {
				// Fallback in case of unexpected errors, but try to avoid full reload
				this.$router.go(-1);
			} finally {
				// Ensure callEnded state is set
				this.callEnded = true;
			}
		},
		stopAudio () {
			this.mutedAudio = !this.mutedAudio;
			if (this.mutedAudio) {
				vroomHandle.muteAudio();
			} else {
				vroomHandle.unmuteAudio();
			}
		},
		stopVideo () {
			this.mutedVideo = !this.mutedVideo;
			if (this.mutedVideo) {
				vroomHandle.muteVideo();
				// Optional: clear local video display if you want it to truly "turn off" for the user
				// const localVideo = document.getElementById('localvideo');
				// if (localVideo && localVideo.srcObject) {
				//   localVideo.srcObject.getTracks().forEach(track => track.stop());
				//   localVideo.srcObject = null;
				// }
			} else {
				vroomHandle.unmuteVideo();
				// If you cleared the stream, you would need to re-acquire it here
				// For simply muting what's sent, just unmuteVideo() is enough.
			}
		},
		calculateAge (dateString) {
			var today = new Date();
			var birthDate = new Date(dateString.split('T')[0]);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		async init (roomId, recorded) {
			Vue = this;
			this.isTearingDown = false;
			this.videoPublishRetryCount = 0;
			Janus.init({
				debug: 'all',
				callback: () => {
					this.janus = new Janus({
						server: socketUrl,
						success: async () => {
							await this.startAppointment(this.$route.params.appointmentId);
							this.janus.attach({
								plugin: 'janus.plugin.videoroom',
								opaqueId: 'videoroom-' + Janus.randomString(12),
								success: function (pluginHandle) {
									vroomHandle = pluginHandle;
									vroomHandle.send({
										message: {
											request: 'exists',
											room: roomId,
										},
										success: (res) => {
											if (res.exists) {
												const reg = Janus.randomString(12);
												const register = {
													request: 'join',
													room: roomId,
													ptype: 'publisher',
													display: reg,
												};
												vroomHandle.send({ message: register });
											} else {
												vroomHandle.send({
													message: {
														request: 'create',
														room: roomId,
														description: 'Doctor',
														publishers: 2,
														record: recorded,
													},
													success: () => {
														const reg = Janus.randomString(12);
														const register = {
															request: 'join',
															room: roomId,
															ptype: 'publisher',
															display: reg,
														};
														vroomHandle.send({ message: register });
													},
												});
											}
										},
									});
								},
								onmessage: async (msg, jsep) => {
									const event = msg.videoroom;
									if (msg && (msg.error || msg.error_code)) {
										this.logJanusPhase('publisher-plugin-error', {
											errorCode: msg.error_code || null,
											error: msg.error || null,
											event: event || null,
										});
									}
									if (event !== undefined && event !== null) {
										if (event === 'joined') {
											this.roomJoinId = msg.id.toString();
											this.localPrivateId = msg.private_id || null;
											await this.addAttendeeForAppointment(
												this.$route.params.appointmentId,
												'IN',
											);
											const list = msg.publishers;
											this.publishers = list;
											for (const f in list) {
												const id = list[f].id;
												const display = list[f].display;
												const audio = list[f].audio_codec;
												const video = list[f].video_codec;
												this.newRemoteFeed(id, display, audio, video, roomId);
											}
											this.publishOwnFeed(true);
										} else if (event === 'event') {
											if (
												msg.publishers !== undefined &&
												msg.publishers !== null
											) {
												const list = msg.publishers;
												this.publishers = list;
												for (const f in list) {
													const id = list[f].id;
													const display = list[f].display;
													const audio = list[f].audio_codec;
													const video = list[f].video_codec;
													this.newRemoteFeed(id, display, audio, video, roomId);
												}
											} else if (
												msg.leaving !== undefined &&
												msg.leaving !== null
											) {
												this.detachRemoteFeed(msg.leaving);
												this.publishers = this.publishers.filter(function (
													obj,
												) {
													return obj.id !== msg.leaving;
												});
												if (this.publishers.length === 0) {
													const video = document.getElementById('patientvideo');
													if (video && video.srcObject) {
														video.srcObject
															.getTracks()
															.forEach((track) => track.stop());
														video.srcObject = null; // Clear the remote video
													}
												}
											} else if (
												msg.unpublished !== undefined &&
												msg.unpublished !== null
											) {
												if (msg.unpublished === 'ok') {
													vroomHandle.hangup();
													return;
												}
												this.detachRemoteFeed(msg.unpublished);
											} else if (
												msg.error !== undefined &&
												msg.error !== null
											) {
												if (msg.error_code === 426) {
													// This is a "no such room" error: give a more meaningful description
												} else if (msg.error_code === 432) {
													// If max number of publishers is reached
													this.detachAllRemoteFeeds();
													vroomHandle.hangup();
													this.janus.destroy();
													this.callEnded = true;
													alert(msg.error);
												} else {
													alert(msg.error);
												}
											}
										} else if (event === 'destroyed') {
											this.endCall();
										}
									}
									if (jsep !== undefined && jsep !== null) {
										vroomHandle.handleRemoteJsep({ jsep: jsep });
									}
								},
								onlocalstream: function (stream) {
									const video = document.getElementById('localvideo');
									if (video && stream) {
										// Check if video element exists and stream is not undefined
										video.srcObject = stream;
										video.muted = true;
										video.play().catch(() => {});
										Vue.localPreviewStream = stream;
										const shouldSendVideo = Vue.parseRouteBoolean(Vue.$route?.params?.videotrack);
										const hasVideoTrack = stream.getVideoTracks().length > 0;
										if (shouldSendVideo && !hasVideoTrack) {
											setTimeout(() => {
												Vue.retryVideoPublish();
											}, 400);
										}
									}
								},
								onlocaltrack: function (track, added) {
									Vue.syncLocalPreviewFromTrack(track, added);
								},
								onremotetrack: function (track, mid, added) {
									// Can be used for fine-grained track management if needed
								},
								oncleanup: function () {
									// Callback when pluginHandle is cleaned up
								},
                // eslint-disable-next-line handle-callback-err
								error: function (error) {
									// Combined error callback
								},
								consentDialog: function (on) {
									// Consent dialog for media access
								},
								iceState: function (state) {
									Vue.logJanusPhase('publisher-ice-state', {
										state: state,
									});
								},
								mediaState: function (medium, on) {
									// Media state changes (e.g., 'audio' or 'video' 'on'/'off')
								},
								webrtcState: function (on) {
									// WebRTC state changes (e.g., 'up'/'down')
								},
								slowLink: function (uplink, nacks) {
									// Slow link notifications
								},
								onremotestream: function (stream) {
									if (stream !== undefined) {
										const video = document.getElementById('patientvideo');
										const audio = document.getElementById('remoteaudio');
										if (video) {
											// Ensure element exists
											video.srcObject = stream;
										}
										if (audio) {
											audio.srcObject = stream;
											audio.muted = false;
											audio.volume = 1.0;
											audio.play().catch(() => {});
										}
									}
								},
								ondata: function (data) {
									// Data channel message received
								},
								ondataopen: function () {
									// Data channel opened
								},
								ondetached: function () {
									// Plugin handle detached
								},
							});
						},
            // eslint-disable-next-line handle-callback-err
						error: (error) => {
							Vue.snackStatus = true;
							Vue.title = 'Error connecting to server, please try again!';
							Vue.snackColor = 'deep-orange darken-4';
							// Set callEnded here, but reJoin should re-initiate
							this.callEnded = true;
							this.reJoin();
						},
						destroyed: function () {
							// Clean up after Janus destroy
							// Avoid reloading the page here. The endCall or destroyed lifecycle should handle state.
							if (Vue) {
								// Ensure all relevant handles are nullified to prevent memory leaks
								Vue.detachAllRemoteFeeds();
								Vue.janus = null;
								vroomHandle = null;
								Vue.callEnded = true; // Indicate call has ended
							}
						},
					});
				},
			});
		},
		publishOwnFeed (useAudio) {
			const shouldSendVideo = this.parseRouteBoolean(this.$route?.params?.videotrack);
			vroomHandle.createOffer({
				tracks: [
					{
						type: 'audio',
						capture: true,
						recv: false,
						add: true,
						remove: !useAudio,
					},
					{
						type: 'video',
						capture: true,
						recv: false,
						add: shouldSendVideo,
						remove: !shouldSendVideo,
					},
				],
				success: function (jsep) {
					Janus.debug('Got publisher SDP!');
					Janus.debug(jsep);
					const publish = {
						request: 'publish',
						audio: useAudio,
						video: shouldSendVideo,
					};
					vroomHandle.send({ message: publish, jsep: jsep });
				},
				error: function (error) {
					Janus.error('WebRTC error on publishOwnFeed:', error);
					// If there's an error with audio, try without audio (if that's the intention)
					// if (useAudio) {
					// 	Vue.publishOwnFeed(false); // Call with Vue context
					// }
				},
			});
		},
		retryVideoPublish () {
			const shouldSendVideo = this.parseRouteBoolean(this.$route?.params?.videotrack);
			if (!shouldSendVideo || !vroomHandle) return;
			if (this.videoPublishRetryCount >= 2) return;
			this.videoPublishRetryCount += 1;
			vroomHandle.createOffer({
				tracks: [
					{
						type: 'audio',
						capture: true,
						recv: false,
						replace: true,
						add: true,
						remove: this.mutedAudio,
					},
					{
						type: 'video',
						capture: true,
						recv: false,
						replace: true,
						add: true,
					},
				],
				success: (jsep) => {
					vroomHandle.send({
						message: {
							request: 'configure',
							audio: !this.mutedAudio,
							video: true,
						},
						jsep: jsep,
					});
				},
				error: () => {},
			});
		},
		syncLocalPreviewFromTrack (track, added) {
			if (!this.videoTrack || !track || track.kind !== 'video') return;
			if (!this.localPreviewStream) {
				this.localPreviewStream = new MediaStream();
			}
			const stream = this.localPreviewStream;
			if (added) {
				const exists = stream.getTracks().some((existingTrack) => existingTrack.id === track.id);
				if (!exists) {
					stream.addTrack(track);
				}
			} else {
				stream.getTracks().forEach((existingTrack) => {
					if (existingTrack.id === track.id) {
						stream.removeTrack(existingTrack);
					}
				});
			}
			const localVideo = document.getElementById('localvideo');
			if (!localVideo) return;
			const hasVideoTrack = stream.getVideoTracks().length > 0;
			localVideo.srcObject = hasVideoTrack ? stream : null;
			if (hasVideoTrack) {
				localVideo.muted = true;
				localVideo.play().catch(() => {});
			}
		},
		attachRemoteMediaStream (stream) {
			if (!stream) return;
			const video = document.getElementById('patientvideo');
			const audio = document.getElementById('remoteaudio');
			if (video) {
				video.srcObject = stream;
				video.muted = false;
				video.volume = 1.0;
				video.play().catch(() => {});
			}
			if (audio) {
				audio.srcObject = stream;
				audio.muted = false;
				audio.volume = 1.0;
				audio.play().catch(() => {});
			}
		},
		handleRemoteTrackPlayback (remoteFeed, track, added) {
			if (!remoteFeed || !track) return;
			const trackId = track.id || `${track.kind}-unknown`;
			const feedId = remoteFeed.rfid || null;
			if (!remoteFeed.remoteMediaStream) {
				remoteFeed.remoteMediaStream = new MediaStream();
			}
			const stream = remoteFeed.remoteMediaStream;
			if (added) {
				const debugKey = `${feedId || 'unknown'}:${track.kind}:${trackId}:${Date.now()}`;
				this.$set(this.remoteTrackDebugById, debugKey, {
					kind: track.kind,
					addedAt: Date.now(),
					unmutedAt: null,
					feedId: feedId,
					trackId: trackId,
				});
				this.logJanusPhase('remote-track-added', {
					debugKey: debugKey,
					trackId: trackId,
					kind: track.kind,
					feedId: feedId,
				});
				track.onunmute = () => {
					const debug = this.remoteTrackDebugById[debugKey];
					if (debug && !debug.unmutedAt) {
						debug.unmutedAt = Date.now();
					}
					if (this.remoteTrackTimeoutsByKey[debugKey]) {
						clearTimeout(this.remoteTrackTimeoutsByKey[debugKey]);
						this.$delete(this.remoteTrackTimeoutsByKey, debugKey);
					}
					this.logJanusPhase('remote-track-unmuted', {
						debugKey: debugKey,
						trackId: trackId,
						kind: track.kind,
						feedId: feedId,
						timeToUnmuteMs: debug && debug.addedAt ? Date.now() - debug.addedAt : null,
					});
				};
				const timeoutId = setTimeout(() => {
					const debug = this.remoteTrackDebugById[debugKey];
					if (debug && !debug.unmutedAt) {
						this.logJanusPhase('remote-track-added-no-unmute-timeout', {
							debugKey: debugKey,
							trackId: trackId,
							kind: track.kind,
							feedId: feedId,
							timeoutMs: 5000,
						});
					}
				}, 5000);
				this.$set(this.remoteTrackTimeoutsByKey, debugKey, timeoutId);
				const exists = stream.getTracks().some((existingTrack) => existingTrack.id === track.id);
				if (!exists) {
					stream.addTrack(track);
				}
				this.attachRemoteMediaStream(stream);
				return;
			}
			stream.getTracks().forEach((existingTrack) => {
				if (existingTrack.id === track.id) {
					stream.removeTrack(existingTrack);
				}
			});
			this.logJanusPhase('remote-track-removed', {
				trackId: trackId,
				kind: track.kind,
				feedId: feedId,
			});
			this.attachRemoteMediaStream(stream);
		},
		newRemoteFeed (id, display, audio, video, roomId) {
			const feedKey = this.normalizeFeedId(id);
			if (!feedKey) return;
			if (this.roomJoinId && feedKey === this.normalizeFeedId(this.roomJoinId)) return;
			if (this.remoteFeedsByFeedId[feedKey]) return;
			let remoteFeed = null;
			this.janus.attach({
				plugin: 'janus.plugin.videoroom',
				opaqueId: 'videoroom-' + Janus.randomString(12),
				success: function (pluginHandle) {
					remoteFeed = pluginHandle;
					remoteFeed.rfid = feedKey;
					Vue.$set(Vue.remoteFeedsByFeedId, feedKey, remoteFeed);
					const subscribe = {
						request: 'join',
						room: roomId,
						ptype: 'subscriber',
						feed: id,
					};
					if (Vue.localPrivateId) {
						subscribe.private_id = Vue.localPrivateId;
					}
					remoteFeed.videoCodec = video;
					remoteFeed.send({ message: subscribe });
				},
				onmessage: function (msg, jsep) {
					if (msg && (msg.error || msg.error_code)) {
						Vue.logJanusPhase('subscriber-plugin-error', {
							feedId: feedKey,
							errorCode: msg.error_code || null,
							error: msg.error || null,
							event: msg.videoroom || null,
						});
					}
					if (jsep) {
						remoteFeed.createAnswer({
							jsep: jsep,
							tracks: [
								{
									type: 'audio',
									capture: false,
									recv: true,
								},
								{
									type: 'video',
									capture: false,
									recv: true,
								},
							],
							success: function (jsep) {
								const body = { request: 'start', room: roomId };
								remoteFeed.send({ message: body, jsep: jsep });
							},
              // eslint-disable-next-line handle-callback-err
							error: function (error) {
								// console.error('WebRTC error on remote feed answer:', error);
							},
						});
					}
				},
				onremotestream: function (stream) {
					if (stream !== undefined) {
						Vue.attachRemoteMediaStream(stream);
					}
				},
				onremotetrack: function (track, mid, added) {
					Vue.handleRemoteTrackPlayback(remoteFeed, track, added);
				},
				oncleanup: function () {
					Vue.$delete(Vue.remoteFeedsByFeedId, feedKey);
				},
				iceState: function (state) {
					Vue.logJanusPhase('subscriber-ice-state', {
						feedId: feedKey,
						state: state,
					});
				},
				ondetached: function () {
					Vue.$delete(Vue.remoteFeedsByFeedId, feedKey);
				},
			});
		},
		async getAllNotes () {
			this.loading = true;
			await this.$store.dispatch(
				'appointments/getNotesWithPatient',
				parseInt(this.detailedUser?.userData.id),
			);
			this.myNotes = this.notesFromRepo;
			this.loading = false;
		},
	},
};
</script>
<style scoped>
::-webkit-scrollbar {
	width: 0px !important;
}
.remote-video-stage {
	position: relative;
	border-radius: 8px;
	background-color: black;
	width: 100%;
	height: 100%;
	min-height: 300px;
	overflow: hidden;
}

.local-overlay {
	position: absolute;
	top: 16px;
	right: 16px;
	width: min(28%, 260px);
	aspect-ratio: 4 / 3;
	border-radius: 8px;
	overflow: hidden;
	z-index: 12;
	box-shadow: 0 4px 18px rgba(0, 0, 0, 0.45);
	background: #111;
}

.floating-call-controls {
	position: absolute;
	left: 50%;
	bottom: 18px;
	transform: translateX(-50%);
	z-index: 2147483000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	border-radius: 0;
	background: transparent;
	backdrop-filter: none;
}

.remote-audio-element {
	position: absolute;
	width: 1px;
	height: 1px;
	opacity: 0;
	pointer-events: none;
	left: -9999px;
	top: -9999px;
}
</style>
